import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { WysiwygContent } from "components"
import COLOR_PALETTE from "constants/color-palette"
import { Radium } from "higher-order-components"
import { H6, Space, Interactive, A, TickModalIcon, AlertIcon } from "AtomicComponents"
import classnames from "classnames"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

const MyMazdaPolicyItem = props => {
  const {
    heading,
    description,
    imageSrc,
    buttonLinkText,
    buttonUrl,
    isActive,
    isExpired,
    policyType
  } = props

  return (
    <div style={styles.tile}>
      <div style={styles.image(isActive)}>
        <img style={{ maxHeight: "100%" }} src={imageSrc} />
        {isExpired ? (
          policyType === "Warranty" ? null : (
            <AlertIcon style={styles.icon} />
          )
        ) : (
          isActive && <TickModalIcon style={styles.icon} />
        )}
      </div>
      <div style={{ padding: `${isActive ? "1.5em" : "0"} 1em 1em` }}>
        <H6 withDetails>{heading}</H6>
        <Space />
        {description && (
          <WysiwygContent
            xmlString={description}
            style={{
              color: isExpired && policyType !== "Warranty" ? COLOR_PALETTE.RED : "inherit"
            }} />
        )}
      </div>
      <div style={{ padding: "0 1em 1em" }}>
        <div style={styles.hr} />
        {isActive ? (
          <Link
            to={buttonUrl}
            style={styles.button}
            className={classnames({
              [typographyStyles.withoutStyle]: true
            })}>
            <Interactive>{buttonLinkText}</Interactive>
          </Link>
        ) : (
          <A href={buttonUrl} withoutStyle external>
            <Interactive>{buttonLinkText}</Interactive>
          </A>
        )}
      </div>
    </div>
  )
}

const styles = {
  tile: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    backgroundColor: "white",
    boxSizing: "border-box",
    border: `1px solid ${COLOR_PALETTE.GRAY}`,
    flexDirection: "column",
    margin: "0 1em 2em 1em",
    justifyContent: "space-between",
    textAlign: "center",
    width: "280px",
    maxWidth: "280px",
    flex: "1 0 auto"
  },
  icon: {
    width: "2.25em",
    height: "2.25em",
    position: "absolute",
    bottom: "-1.125em",
    left: "50%",
    marginLeft: "-1.125em"
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em",
    paddingBottom: "0.5em"
  },
  button: {
    color: COLOR_PALETTE.GRAY_DARK,
    transition: "color 0.25s",
    cursor: "pointer",
    ":hover": {
      color: COLOR_PALETTE.GRAY_DARKER
    },
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "87%"
  },
  image: isActive => ({
    padding: "1.5em",
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    height: "200px",
    backgroundColor: isActive ? COLOR_PALETTE.GRAY_LIGHTER : "transparent"
  })
}

MyMazdaPolicyItem.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  policyType: PropTypes.string,
  imageSrc: PropTypes.string,
  buttonLinkText: PropTypes.string,
  buttonUrl: PropTypes.string,
  isActive: PropTypes.bool,
  isExpired: PropTypes.bool
}

export default Radium(MyMazdaPolicyItem)



// WEBPACK FOOTER //
// ./src/blocks/mymazda/policies/item.jsx